import * as DomBuilder from "./dom-builder.js";
import * as FormatError from "../format-error.js";

/**
 *
 * @version 2026-09-04
 * @author Patrik Harag
 */
export default class ComponentDatasetsTable {

    /** @type {function(Dataset)} */
    #onDelete;
    /** @type {function(Dataset|null)} */
    #onEdit;
    /** @type {HTMLElement} */
    #tableBody = DomBuilder.element('tbody');

    /**
     *
     * @param controller {Controller}
     * @param onDelete {function(Dataset)}
     * @param onEdit {function(Dataset|null)}
     */
    constructor(controller, onDelete, onEdit) {
        this.#onDelete = onDelete;
        this.#onEdit = onEdit;
    }

    createNode() {
        return DomBuilder.div({ class: 'table-responsive' }, [
            DomBuilder.element('table', { class: 'table table-striped' }, [
                DomBuilder.element('thead', null, [
                    DomBuilder.element('td', null, 'Dataset name'),
                    DomBuilder.element('td', null, 'Type'),
                    DomBuilder.element('td', null, 'Currency'),
                    DomBuilder.element('td', null, 'Items'),
                    DomBuilder.element('td')
                ]),
                this.#tableBody
            ])
        ]);
    }

    refresh(datasets) {
        this.#tableBody.replaceChildren();

        datasets.forEach(dataset => {
            let itemsCell;
            if (dataset.getException() !== null) {
                itemsCell = DomBuilder.element('td', null, DomBuilder.span("Error: " + FormatError.format(dataset.getException())));
            } else {
                itemsCell = DomBuilder.element('td', null, String(dataset.getTransactions().length));
            }

            let row = DomBuilder.element('tr', null, [
                DomBuilder.element('td', null, dataset.getName()),
                DomBuilder.element('td', null, dataset.getDataType()),
                DomBuilder.element('td', null, dataset.getCurrency()),
                itemsCell,
                DomBuilder.element('td', { class: 'options-cell' }, [
                    DomBuilder.link('', { class: 'fa fa-edit' }, e => {
                        this.#onEdit(dataset);
                    }),
                    DomBuilder.link('', { class: 'fa fa-trash' }, e => {
                        this.#onDelete(dataset);
                    })
                ])
            ]);
            this.#tableBody.append(row);
        });

        this.#tableBody.append(this.#createLastRow());
    }

    #createLastRow() {
        return DomBuilder.element('tr', null, [
            DomBuilder.element('td'),
            DomBuilder.element('td'),
            DomBuilder.element('td'),
            DomBuilder.element('td'),
            DomBuilder.element('td', { class: 'options-cell' }, [
                DomBuilder.link('', { class: 'fa fa-plus' }, e => {
                    this.#onEdit(null);
                })
            ])
        ]);
    }
}
